<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>已转单报价单</el-breadcrumb-item>
    </el-breadcrumb>
    <quotation-list :deleted="0" :status="5"></quotation-list>
  </div>
</template>

<script>
import Quotation from '../customer/quotation.vue'
import QuotationList from './list'
export default {
  components: { QuotationList },
}
</script>